import { SharingMode } from '../../types/scenarios';
import { compoundGrowthSeries } from './../../../services/statistics';
import { IOwnershipMode, VehicleType } from './../../types/city';

// Load the mapping into a usable table

import occupancy from '../../../data/occupancy';
import { IRow } from './../../../data/occupancy';

// data about the table
const TABLE_START_YEAR = 2005;
const TABLE_END_YEAR = 2040;

const TABLE_SIZE = 21; //


const getOwnershipStruct = (): IOwnershipMode => {
  return {
    autoRickshaw: {
      commercial: 0,
    },
    car: {
      commercial: 0,
      private: 0,
      public: 0,
    },
    publicTransit: {
      bus: 0,
      metro: 0,
    },
    twoWheel: {
      commercial: 0,
      private: 0,
    },
  }
}

interface IOwnershipMap {
  [key: number]: IOwnershipMode;
}

const initializeStructs = (startYear: number, endYear: number): IOwnershipMap => {
  const structs: IOwnershipMap = {};
  for (let i = startYear; i <= endYear; i++) {
    structs[i] = getOwnershipStruct();
  }

  return structs;
}

// NOTE THESE VALUES ARE STORED AS NUMBERS GREATER THAN 1!!
const processTable = (table: IRow[]) => {

  const startYear = TABLE_START_YEAR;
  const endYear = TABLE_END_YEAR;

  const finalMap = {
    [SharingMode.BAU]: initializeStructs(startYear, endYear),
    [SharingMode.Sharing]: initializeStructs(startYear, endYear),
    [SharingMode.ExtremeSharing]: initializeStructs(startYear, endYear),
  };


  table.forEach(row => {
    const localMap = finalMap[row.sharingType];
    for (let year = startYear; year <= endYear; year++) {
      localMap[year][row.vehicleType][row.ownership] = row[year];
    }
  });

  // Let's manually add the metro data
  // Public Buses
  for (let year = startYear; year <= endYear; year++) {
    finalMap[SharingMode.BAU][year][VehicleType.publicTransit].metro = 100;
    finalMap[SharingMode.Sharing][year][VehicleType.publicTransit].metro = 100;
    finalMap[SharingMode.ExtremeSharing][year][VehicleType.publicTransit].metro = 100;
  }

  // Public Metro
  const busStart = 41.6
  // Endval - StartVal / ()
  // had to hardcode a positive into there
  // const busGrowth = Math.pow(Math.abs((38 - 41.6)), (1 / (2050 - 2005)) ) - 1 ;
  const busGrowth = -0.00200940083540824; // Cell F70, divided by 100
  const busSeries = compoundGrowthSeries(busStart, busGrowth, endYear - startYear);
  // console.log('busSeries', busSeries);
  for (let year = startYear; year <= endYear; year++) {
    const yearVal = busSeries[year - startYear];
    finalMap[SharingMode.BAU][year][VehicleType.publicTransit].bus = yearVal;
    finalMap[SharingMode.Sharing][year][VehicleType.publicTransit].bus = yearVal;
    finalMap[SharingMode.ExtremeSharing][year][VehicleType.publicTransit].bus = yearVal;
  }

  return finalMap;
}

export default processTable(occupancy);



// WEBPACK FOOTER //
// ./src/store/selectors/vehicleDistanceTraveled/table.ts